/**
 * @generated SignedSource<<bcb97833449275fad49dde3afa710ed1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreProductExpireBatchStatus = "ACTIVE" | "INACTIVE";
export type ProductExpireBatchStatusFooterSetBatchStatusMutation$variables = {
  employeeId?: string | null;
  productExpireBatchId: string;
  productId: string;
  status: StoreProductExpireBatchStatus;
};
export type ProductExpireBatchStatusFooterSetBatchStatusMutation$data = {
  readonly storeProduct: {
    readonly expireBatch: {
      readonly setBatchStatus: {
        readonly id: string;
        readonly status: StoreProductExpireBatchStatus;
      } | null;
    } | null;
  } | null;
};
export type ProductExpireBatchStatusFooterSetBatchStatusMutation$rawResponse = {
  readonly storeProduct: {
    readonly expireBatch: {
      readonly setBatchStatus: {
        readonly id: string;
        readonly status: StoreProductExpireBatchStatus;
      } | null;
    } | null;
  } | null;
};
export type ProductExpireBatchStatusFooterSetBatchStatusMutation = {
  rawResponse: ProductExpireBatchStatusFooterSetBatchStatusMutation$rawResponse;
  response: ProductExpireBatchStatusFooterSetBatchStatusMutation$data;
  variables: ProductExpireBatchStatusFooterSetBatchStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productExpireBatchId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productId"
      }
    ],
    "concreteType": "StoreProductMutation",
    "kind": "LinkedField",
    "name": "storeProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "productExpireBatchId"
          }
        ],
        "concreteType": "StoreProductExpireBatchMutation",
        "kind": "LinkedField",
        "name": "expireBatch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "employeeId",
                "variableName": "employeeId"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status"
              }
            ],
            "concreteType": "StoreProductExpireBatch",
            "kind": "LinkedField",
            "name": "setBatchStatus",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductExpireBatchStatusFooterSetBatchStatusMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductExpireBatchStatusFooterSetBatchStatusMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "15c220fcdc1f2c06d4249b0639af5c32",
    "id": null,
    "metadata": {},
    "name": "ProductExpireBatchStatusFooterSetBatchStatusMutation",
    "operationKind": "mutation",
    "text": "mutation ProductExpireBatchStatusFooterSetBatchStatusMutation(\n  $productId: ID!\n  $productExpireBatchId: ID!\n  $status: StoreProductExpireBatchStatus!\n  $employeeId: ID\n) {\n  storeProduct(id: $productId) {\n    expireBatch(id: $productExpireBatchId) {\n      setBatchStatus(status: $status, employeeId: $employeeId) {\n        id\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca7753d63e46b6d63bd0f8a19a6c942c";

export default node;
